import {
    CalculatorApplicantSummaryDTO,
    DesiredVehicleApplicantSummaryDTO,
    WorkApplicantSummaryDTO,
    FieldApplicantSummary, HomeApplicantSummaryDTO,
    PersonalApplicantSummaryDTO,
    ContinueHeaderSummaryDTO, ApplicantInfoSummaryDTO, EmploymentInfoSummaryDTO,
    ReferencesSummaryDTO,
    DocumentsSummaryDTO
} from '../types/mx/creditoReal/epics';
import {
    CalculatorStepViewFieldErrorState, HomeDataStepViewFieldErrorState,
    PersonalDataStepViewFieldErrorState,
    WorkDataStepViewErrorFieldState
} from '../types/mx/creditoReal/reducers';
import {
    PersonalDataTurboCashStepViewFieldErrorState,
    WorkDataTurboCashStepViewErrorFieldState
} from '../types/mx/turboCash/reducers';
import {State} from '../types/mx/reducers';

export const GOT_API_ERROR_ACTION = {
    name: 'GOT_API_ERROR_ACTION',
    action: error => ({
        error,
        type: GOT_API_ERROR_ACTION.name,
    })
};

export const GO_TO_CALCULATOR_MX_ACTION = {
    name: 'GO_TO_CALCULATOR_MX_ACTION',
    action: () => ({
        type: GO_TO_CALCULATOR_MX_ACTION.name
    })
};

export const GO_TO_APPLICANT_DATA_MX_ACTION = {
    name: 'GO_TO_APPLICANT_DATA_MX_ACTION',
    action: () => ({
        type: GO_TO_APPLICANT_DATA_MX_ACTION.name
    })
};

export const SAVE_APPLICANT_DATA_MX_ACTION = {
    name: 'SAVE_APPLICANT_DATA_MX_ACTION',
    action: () => ({
        type: SAVE_APPLICANT_DATA_MX_ACTION.name
    })
};

export const SEND_HUBSPOT_DATA_ACTION = {
    name: 'SEND_HUBSPOT_DATA_ACTION',
    action: () => ({
        type: SEND_HUBSPOT_DATA_ACTION.name
    })
};

export const SAVE_CALCULATOR_DATA_MX_ACTION = {
    name: 'SAVE_CALCULATOR_DATA_MX_ACTION',
    action: () => ({
        type: SAVE_CALCULATOR_DATA_MX_ACTION.name
    })
};

export const GO_TO_APPLICANT_DOMICILE_MX_ACTION = {
    name: 'GO_TO_APPLICANT_DOMICILE_MX_ACTION',
    action: () => ({
        type: GO_TO_APPLICANT_DOMICILE_MX_ACTION.name
    })
};

export const SAVE_APPLICANT_DOMICILE_MX_ACTION = {
    name: 'SAVE_APPLICANT_DOMICILE_MX_ACTION',
    action: () => ({
        type: SAVE_APPLICANT_DOMICILE_MX_ACTION.name
    })
};

export const SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION = {
    name: 'SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION',
    action: () => ({
        type: SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.name
    })
};

export const CLEAN_NIP_MX_ACTION = {
    name: 'CLEAN_NIP_MX_ACTION',
    action: () => ({
        type: CLEAN_NIP_MX_ACTION.name
    })
};

export const GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION = {
    name: 'GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION',
    action: () => ({
        type: GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION.name
    })
};

export const GO_TO_FILES_UPLOAD_MX_ACTION = {
    name: 'GO_TO_FILES_UPLOAD_MX_ACTION',
    action: () => ({
        type: GO_TO_FILES_UPLOAD_MX_ACTION.name
    })
};

export const SAVE_APPLICANT_DATA_AND_SEND_NIP_MX_ACTION = {
    name: 'SAVE_APPLICANT_DATA_AND_SEND_NIP_MX_ACTION',
    action: () => ({
        type: SAVE_APPLICANT_DATA_AND_SEND_NIP_MX_ACTION.name
    })
};

export const CHANGE_BUREAU_NIP_ACTION = {
    name: 'CHANGE_BUREAU_NIP_ACTION',
    action: nip => ({
        nip,
        type: CHANGE_BUREAU_NIP_ACTION.name
    })
};

export const SET_SKIP_NIP_VALIDATION_ACTION = {
    name: 'SET_SKIP_NIP_VALIDATION_ACTION',
    action: skip => ({
        skip,
        type: SET_SKIP_NIP_VALIDATION_ACTION.name
    })
};

export const SKIP_NIP_MX_ACTION = {
    name: 'SKIP_NIP_MX_ACTION',
    action: () => ({
        type: SKIP_NIP_MX_ACTION.name
    })
};

export const GO_TO_BUREAU_VALIDATE_NIP_MX_ACTION = {
    name: 'GO_TO_BUREAU_VALIDATE_NIP_MX_ACTION',
    action: () => ({
        type: GO_TO_BUREAU_VALIDATE_NIP_MX_ACTION.name
    })
};

export const VALIDATE_PROFILE_MX_ACTION = {
    name: 'VALIDATE_PROFILE_MX_ACTION',
    action: () => ({
        type: VALIDATE_PROFILE_MX_ACTION.name
    })
};

export const VALIDATE_NIP_MX_ACTION = {
    name: 'VALIDATE_NIP_MX_ACTION',
    action: () => ({
        type: VALIDATE_NIP_MX_ACTION.name
    })
};

export const VALIDATE_BUREAU_NIP_MX_ACTION = {
    name: 'VALIDATE_BUREAU_NIP_MX_ACTION',
    action: () => ({
        type: VALIDATE_BUREAU_NIP_MX_ACTION.name
    })
};

export const RESEND_NIP_MX_ACTION = {
    name: 'RESEND_NIP_MX_ACTION',
    action: () => ({
        type: RESEND_NIP_MX_ACTION.name
    })
};

export const GO_TO_CREDIT_HISTORY_MX_ACTION = {
    name: 'GO_TO_CREDIT_HISTORY_MX_ACTION',
    action: () => ({
        type: GO_TO_CREDIT_HISTORY_MX_ACTION.name
    })
};

export const GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION = {
    name: 'GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION',
    action: (token: string = '', comesFromSummary: boolean = false) => ({
        token,
        comesFromSummary,
        type: GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.name
    })
};

export const GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION = {
    name: 'GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION',
    action: () => ({
        type: GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION.name
    })
};

export const SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION = {
    name: 'SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION',
    action: () => ({
        type: SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION.name
    })
};

export const SET_CREDIT_BUREAU_VALIDATION_MX_ACTION = {
    name: 'SET_CREDIT_BUREAU_VALIDATION_MX_ACTION',
    action: bureauAlreadyValidated => ({
        bureauAlreadyValidated,
        type: SET_CREDIT_BUREAU_VALIDATION_MX_ACTION.name
    })
};

export const SET_BUREAU_FAILED_ACTION = {
    name: 'SET_BUREAU_FAILED_ACTION',
    action: hasBureauError => ({
        hasBureauError,
        type: SET_BUREAU_FAILED_ACTION.name
    })
};

export const SAVE_CREDIT_HISTORY_MX_ACTION = {
    name: 'SAVE_CREDIT_HISTORY_MX_ACTION',
    action: () => ({
        type: SAVE_CREDIT_HISTORY_MX_ACTION.name
    })
};

export const GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION = {
    name: 'GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION',
    action: () => ({
        type: GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.name
    })
};

export const SAVE_APPLICANT_EMPLOYMENT_MX_ACTION = {
    name: 'SAVE_APPLICANT_EMPLOYMENT_MX_ACTION',
    action: () => ({
        type: SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.name
    })
};

export const GO_TO_OTHER_REFERENCES_MX_ACTION = {
    name: 'GO_TO_OTHER_REFERENCES_MX_ACTION',
    action: () => ({
        type: GO_TO_OTHER_REFERENCES_MX_ACTION.name
    })
};

export const SAVE_OTHER_REFERENCES_MX_ACTION = {
    name: 'SAVE_OTHER_REFERENCES_MX_ACTION',
    action: () => ({
        type: SAVE_OTHER_REFERENCES_MX_ACTION.name
    })
};

export const GO_TO_INSURANCES_MX_ACTION = {
    name: 'GO_TO_INSURANCES_MX_ACTION',
    action: () => ({
        type: GO_TO_INSURANCES_MX_ACTION.name
    })
};

export const SAVE_INSURANCES_MX_ACTION = {
    name: 'SAVE_INSURANCES_MX_ACTION',
    action: () => ({
        type: SAVE_INSURANCES_MX_ACTION.name
    })
};

export const SAVE_MARKETING_MX_ACTION = {
    name: 'SAVE_MARKETING_MX_ACTION',
    action: channelSelected => ({
        channelSelected,
        type: SAVE_MARKETING_MX_ACTION.name
    })
};

export const GO_TO_SENT_LOAN_APPLICATION_MX_ACTION = {
    name: 'GO_TO_SENT_LOAN_APPLICATION_MX_ACTION',
    action: () => ({
        type: GO_TO_SENT_LOAN_APPLICATION_MX_ACTION.name
    })
};

export const GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION = {
    name: 'GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION',
    action: () => ({
        type: GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.name
    })
};

export const GET_LOAN_APPLICATION_SUMMARY_MX_ACTION = {
    name: 'GET_LOAN_APPLICATION_SUMMARY_MX_ACTION',
    action: token => ({
        token,
        type: GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name
    })
};

export const GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION = {
    name: 'GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION',
    action: token => ({
        token,
        type: GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.name
    })
};

export const GET_LOAN_APPLICATION_CALCULATOR_MX_ACTION = {
    name: 'GET_LOAN_APPLICATION_CALCULATOR_MX_ACTION',
    action: token => ({
        token,
        type: GET_LOAN_APPLICATION_CALCULATOR_MX_ACTION.name
    })
};

export const GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION = {
    name: 'GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION',
    action: loanApplication => ({
        loanApplication,
        type: GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION.name
    })
};

export const GOT_LOAN_APPLICATION_BY_TOKEN = {
    name: 'GOT_LOAN_APPLICATION_BY_TOKEN',
    action: loanApplication => ({
        loanApplication,
        type: GOT_LOAN_APPLICATION_BY_TOKEN.name
    })
};

export const GET_LOAN_APPLICATION_TO_EDIT_MX_ACTION = {
    name: 'GET_LOAN_APPLICATION_TO_EDIT_MX_ACTION',
    action: token => ({
        token,
        type: GET_LOAN_APPLICATION_TO_EDIT_MX_ACTION.name
    })
};

export const GOT_LOAN_APPLICATION_TO_EDIT_MX_ACTION = {
    name: 'GOT_LOAN_APPLICATION_TO_EDIT_MX_ACTION',
    action: loanApplication => ({
        loanApplication,
        type: GOT_LOAN_APPLICATION_TO_EDIT_MX_ACTION.name
    })
};

export const SET_RETURN_TO_SUMMARY = {
    name: 'SET_RETURN_TO_SUMMARY',
    action: stepId => ({
        stepId,
        type: SET_RETURN_TO_SUMMARY.name
    })
};

export const FINISH_LOAN_APPLICATION_ACTION = {
    name: 'FINISH_LOAN_APPLICATION_ACTION',
    action: () => ({
        type: FINISH_LOAN_APPLICATION_ACTION.name
    })
};

export const GOT_INSURANCE_ERROR_ACTION = {
    name: 'GOT_INSURANCE_ERROR_ACTION',
    action: () => ({
        type: GOT_INSURANCE_ERROR_ACTION.name
    })
};

export const APPLICANT_HAS_ANOTHER_APPLICATION_MX_ACTION = {
    name: 'APPLICANT_HAS_ANOTHER_APPLICATION_MX_ACTION',
    action: () => ({
        type: APPLICANT_HAS_ANOTHER_APPLICATION_MX_ACTION.name
    })
};

export const NOT_FOUND_LOCATION_ERROR_MX_ACTION = {
    name: 'NOT_FOUND_LOCATION_ERROR_MX_ACTION',
    action: () => ({
        type: NOT_FOUND_LOCATION_ERROR_MX_ACTION.name
    })
};

export const FILL_CALCULATOR_DATA_MX_ACTION = {
    name: 'FILL_CALCULATOR_DATA_MX_ACTION',
    action: () => ({
        type: FILL_CALCULATOR_DATA_MX_ACTION.name
    })
};

export const SET_CALCULATOR_DATA_STATE_ACTION = {
    name: 'SET_CALCULATOR_DATA_STATE_ACTION',
    action: (fieldSummary: FieldApplicantSummary<CalculatorApplicantSummaryDTO, CalculatorStepViewFieldErrorState>) =>
        ({
            fieldSummary,
            type: SET_CALCULATOR_DATA_STATE_ACTION.name
        })
};

export const SET_DESIRED_VEHICLE_DATA_STATE_ACTION = {
    name: 'SET_DESIRED_VEHICLE_DATA_STATE_ACTION',
    action: (fieldSummary: FieldApplicantSummary<DesiredVehicleApplicantSummaryDTO,
        CalculatorStepViewFieldErrorState>) =>
        ({
            fieldSummary,
            type: SET_DESIRED_VEHICLE_DATA_STATE_ACTION.name
        })
};

export const SET_PERSONAL_DATA_STATE_ACTION = {
    name: 'SET_PERSONAL_DATA_STATE_ACTION',
    action: (fieldSummary: FieldApplicantSummary<PersonalApplicantSummaryDTO, PersonalDataStepViewFieldErrorState>) =>
        ({
            fieldSummary,
            type: SET_PERSONAL_DATA_STATE_ACTION.name
        })
};

export const SET_CONTINUE_HEADER_DATA_STATE_ACTION = {
    name: 'SET_CONTINUE_HEADER_DATA_STATE_ACTION',
    action: (continueHeader: ContinueHeaderSummaryDTO) =>
        ({
            continueHeader,
            type: SET_CONTINUE_HEADER_DATA_STATE_ACTION.name
        })
};

export const SET_APPLICANT_INFO_DATA_STATE_ACTION = {
    name: 'SET_APPLICANT_INFO_DATA_STATE_ACTION',
    action: (
        applicantInfo: FieldApplicantSummary<ApplicantInfoSummaryDTO, PersonalDataTurboCashStepViewFieldErrorState>,
        state: State) =>
        ({
            applicantInfo, state,
            type: SET_APPLICANT_INFO_DATA_STATE_ACTION.name
        })
};

export const SET_HOME_DATA_STATE_ACTION = {
    name: 'SET_HOME_DATA_STATE_ACTION',
    action: (fieldSummary: FieldApplicantSummary<HomeApplicantSummaryDTO, HomeDataStepViewFieldErrorState>) =>
        ({
            fieldSummary,
            type: SET_HOME_DATA_STATE_ACTION.name
        })
};

export const SET_EMPLOYMENT_DATA_STATE_ACTION = {
    name: 'SET_EMPLOYMENT_DATA_STATE_ACTION',
    action: (fieldSummary: FieldApplicantSummary<WorkApplicantSummaryDTO, WorkDataStepViewErrorFieldState>) =>
        ({
            fieldSummary,
            type: SET_EMPLOYMENT_DATA_STATE_ACTION.name
        })
};

export const SET_EMPLOYMENT_INFO_DATA_STATE_ACTION = {
    name: 'SET_EMPLOYMENT_INFO_DATA_STATE_ACTION',
    action: (
        employmentInfo: FieldApplicantSummary<EmploymentInfoSummaryDTO, WorkDataTurboCashStepViewErrorFieldState>
    ) =>
        ({
            employmentInfo,
            type: SET_EMPLOYMENT_INFO_DATA_STATE_ACTION.name
        })
};

export const SET_REFERENCES_DATA_STATE_ACTION = {
    name: 'SET_REFERENCES_DATA_STATE_ACTION',
    action: (
        references: FieldApplicantSummary<[ReferencesSummaryDTO], {}>
    ) =>
        ({
            references,
            type: SET_REFERENCES_DATA_STATE_ACTION.name
        })
};

export const SET_DOCUMENTS_DATA_STATE_ACTION = {
    name: 'SET_DOCUMENTS_DATA_STATE_ACTION',
    action: (
        documents: FieldApplicantSummary<[DocumentsSummaryDTO], {}>
    ) =>
        ({
            documents,
            type: SET_DOCUMENTS_DATA_STATE_ACTION.name
        })
};

export const VERIFY_CALCULATOR_DATA = {
    name: 'VERIFY_CALCULATOR_DATA',
    action: () => ({
        type: VERIFY_CALCULATOR_DATA.name
    })
};

export const GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION = {
    name: 'GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION',
    action: () => ({
        type: GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.name
    })
};

export const GO_TO_ACCEPT_QUOTE_MX_ACTION = {
    name: 'GO_TO_ACCEPT_QUOTE_MX_ACTION',
    action: () => ({
        type: GO_TO_ACCEPT_QUOTE_MX_ACTION.name
    })
};

export const SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION = {
    name: 'SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION',
    action: (quoteAccepted: boolean, msgOffer: string = null, offerAccepted: boolean = false) => ({
        quoteAccepted,
        msgOffer,
        offerAccepted,
        type: SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.name
    })
};

export const SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION = {
    name: 'SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION',
    action: (quoteAccepted: boolean) => ({
        quoteAccepted,
        type: SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION.name
    })
};

export const SAVE_TURBO_CASH_DATA_MX_ACTION = {
    name: 'SAVE_TURBO_CASH_DATA_MX_ACTION',
    action: (isInterval: boolean) => ({
        isInterval,
        type: SAVE_TURBO_CASH_DATA_MX_ACTION.name
    })
};

export const CHECK_IF_APPLIES_TO_TURBO_CASH_MX_ACTION = {
    name: 'CHECK_IF_APPLIES_TO_TURBO_CASH_MX_ACTION',
    action: () => ({
        type: CHECK_IF_APPLIES_TO_TURBO_CASH_MX_ACTION.name
    })
};

export const APPLIES_TO_TURBO_CASH_MX_ACTION = {
    name: 'APPLIES_TO_TURBO_CASH_MX_ACTION',
    action: (minDownPayment: number = 0, maxDownPayment: number = 0) => ({
        minDownPayment, maxDownPayment,
        type: APPLIES_TO_TURBO_CASH_MX_ACTION.name
    })
};

export const ON_LOAD_TURBO_CASH_SIMULATOR_MX_ACTION = {
    name: 'ON_LOAD_TURBO_CASH_SIMULATOR_MX_ACTION',
    action: () => ({
        type: ON_LOAD_TURBO_CASH_SIMULATOR_MX_ACTION.name
    })
};

export const ON_LOAD_SIMULATOR_PROFILE_MX_ACTION = {
    name: 'ON_LOAD_SIMULATOR_PROFILE_MX_ACTION',
    action: (profile: boolean = false) => ({
        profile,
        type: ON_LOAD_SIMULATOR_PROFILE_MX_ACTION.name
    })
};

export const CLEAN_STATE_ONCE_FINISHED_LOAN = {
    name: 'CLEAN_STATE_ONCE_FINISHED_LOAN',
    action: () => ({
        type: CLEAN_STATE_ONCE_FINISHED_LOAN.name
    })
};

export const CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH = {
    name: 'CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH',
    action: () => ({
        type: CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name
    })
};

export const GO_TO_HOME_ACTION = {
    name: 'GO_TO_HOME_ACTION',
    action: () => ({
        type: GO_TO_HOME_ACTION.name
    })
};

export const GO_TO_TURBO_CASH_THANKS_ACTION = {
    name: 'GO_TO_TURBO_CASH_THANKS_ACTION',
    action: () => ({
        type: GO_TO_TURBO_CASH_THANKS_ACTION.name
    })
};

export const GO_TO_TURBO_CASH_ACTION = {
    name: 'GO_TO_TURBO_CASH_ACTION',
    action: () => ({
        type: GO_TO_TURBO_CASH_ACTION.name
    })
};

export const GO_TO_SIMULATOR_PROFILE_ACTION = {
    name: 'GO_TO_SIMULATOR_PROFILE_ACTION',
    action: () => ({
        type: GO_TO_SIMULATOR_PROFILE_ACTION.name
    })
};